import React from 'react';
import packageJson from '../../../package.json';

// Get version from package.json
const APP_VERSION = packageJson.version;

export const PageFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full mt-auto px-4 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          RTI Portal v{APP_VERSION}
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          © {currentYear} BACK TO KERALA FOUNDATION
        </p>
        <p className="mt-1 text-[11px] text-gray-400 dark:text-gray-500">
          Developed and maintained by{' '}
          <a
            href="https://www.zhost.in?utm_source=rti_portal&utm_medium=footer&utm_campaign=branding"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
          >
            zHost Cloud Services
          </a>
        </p>
      </div>
    </footer>
  );
};
